import React, {useState} from 'react';
import TabContent from '../../TabContent';
import TabNavItem from '../../TabNavItem';
import AllDocs from './AllDocs';
import AddEditDoctorInfo from './AddEditDoctorInfo';
import AddDoctorInfo from './AddDoctorInfo';
import AddBookingType from './AddBookingType';
import DocInfo from './DocInfo';
import BookingRequests from "./BookingRequests"; // Import DocInfo

function BookingTab() {
    const [activeTab, setActiveTab] = useState('booking');
    const [refreshDoctors, setRefreshDoctors] = useState(false);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [view, setView] = useState('list'); // 'list' or 'detail'

    // Function to handle successful doctor addition
    const handleDoctorAdded = () => {
        setActiveTab('booking'); // Switch to Doctors List tab
        setRefreshDoctors(prev => !prev); // Toggle refresh state to trigger AllDocs refresh
    };

    // Function to handle viewing doctor details
    const handleViewDoctor = (doctor) => {
        setSelectedDoctor(doctor);
        setView('detail');
        setActiveTab('booking'); // Keep active tab as booking but show detail view
    };

    // Function to handle going back to doctors list
    const handleBackToList = () => {
        setView('list');
        setRefreshDoctors(prev => !prev); // Refresh the list
    };

    return (
        <div className="card card-padding shadow-none">
            <div className="container-fluid p-0">
                <div className="card border-0 shadow-none">
                    {/* Header Section */}
                    <div className="card-title mb-0">
                        <i className="bi bi-calendar3 me-2"></i>
                        Appointment Management
                    </div>

                    <div className="card-body p-0">
                        {/* Tab Navigation */}
                        <nav className="nav nav-tabs px-3 pt-2" style={{borderBottom: '1px solid #dee2e6'}}>
                            <TabNavItem
                                id="booking"
                                title="Doctors List"
                                icon="bi bi-person-badge"
                                iconfill="bi bi-person-badge-fill"
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                                onClick={() => {
                                    setView('list');
                                    setActiveTab('booking');
                                }}
                            />
                            <TabNavItem
                                id="bookingType"
                                title="Appointment Types"
                                icon="bi bi-calendar2-check"
                                iconfill="bi bi-calendar2-check-fill"
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                            />
                            <TabNavItem
                                id="bookingRequests"
                                title="Booking Requests"
                                icon="bi bi-calendar3-range "
                                iconfill="bi bi-calendar3-range-fill"
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                            />
                        </nav>

                        {/* Tab Content */}
                        <div className="tab-content p-2">
                            <TabContent id="booking" activeTab={activeTab}>
                                {view === 'list' ? (
                                    <AllDocs refresh={refreshDoctors} onViewDoctor={handleViewDoctor}/>
                                ) : (
                                    <DocInfo doc={selectedDoctor} onBack={handleBackToList}/>
                                )}
                            </TabContent>

                            <TabContent id="bookingType" activeTab={activeTab}>
                                <AddBookingType/>
                            </TabContent>
                            <TabContent id="bookingRequests" activeTab={activeTab}>
                                <BookingRequests/>
                            </TabContent>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BookingTab;